//Detect if Open or Closed and add the park_closed class 
$(function($) {

    'use strict'

    $("span.status:contains('Closed')").addClass('park_closed'); 

}(jQuery)); 